(function () {
  "use strict";
  angular.module("marketPlace.vimeo", []);
})();
